module.exports = __webpack_public_path__ + "static/media/school-profile-banner1.2182ae33.png";